import { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FormControl, Tab, Grid, Table } from "@/comn/components";
import { comnEnvs, comnUtils } from "@/comn/utils";
import { Page, Group, Layout, Button, ExcelUpload } from "@/comn/components";
import { eswiEnvs, eswiUtils } from "@/tra/tancis/eswi/comn";
import {
    useForm,
    useFetch,
    useGrid,
    useResource,
    usePopup,
    useStore,
    useToast,
    useAuth,
    useModal,
    useTab,
    usePage,
} from "@/comn/hooks";
import {
    BASE,
    URLS,
    APIS,
    SF_SCHEMA_HS_VRFN,
    SF_SCHEMA_HS_APP,
    SG_APP_HS_CODE_LIST_R,
    SG_APP_HS_CODE_LIST,
} from "@/tra/tancis/eswi/hs/vrfn/service/EswiHsVrfnService";

export const HS_VRFN_PPUP = (props: any) => {
    /*
     * Declaration Hook, Meta
     * !== Hook, 메타 정보 정의 ==!
     */
    // const pgeUid = "UI-ESWO-0107-040S"; // Page Unique identifier !== 화면 고유 식별자 ==!
    const { pgeUid, menuId } = usePage();
    const pgeTitle = "Items Details"; // Page Title !== 페이지 타이틀 ==!
    const { t } = useTranslation(); // Translation Hook !== 언어 변화 Hook ==!
    const navigate = useNavigate(); // Navigate Hook !== 화면 이동 Hook ==!
    const modal = useModal(); // Modal Window Hook !== Modal 창 Hook ==!
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid }); // Page Store Hook !== 화면 데이터 저장 Hook ==!
    const toast = useToast(); // Toast Message Hook !== Toast 메세지 표시 Hook ==!

    const auth = useAuth(); // Login , User Information Hook !== 로그인, 유저정보 Hook ==!

    const refSubmittable = useRef(false);
    const refSavable = useRef(false);

    const refOfcrInfo = useRef<any>({});

    const { hsAppUuid } = props;

    console.log("props === ", hsAppUuid, props);
    /*
     * Declaration Form
     * !== 폼 정의 ==!
     */
    const form = {
        hsAppForm: useForm({
            defaultSchema: SF_SCHEMA_HS_APP,
            defaultValues: {},
        }),

        hsVrfnForm: useForm({
            defaultSchema: SF_SCHEMA_HS_VRFN,
            defaultValues: {},
        }),
    };

    /*
     * Declaration Fetch
     * !== Fetch 정의 ==!
     */
    const fetch = {
        getHsVrfnInfo: useFetch({
            api: (hsAppUuid) => {
                return APIS.getHsVrfnInfo(hsAppUuid);
            },
            onSuccess: (data) => {
                console.log("getAppDtl onSuccess ==================== ", data);
                if (!data.appInfo.content.info || !data.appInfo.content.info?.hsAppUuid) {
                    // no data
                    modal.openModal({
                        content: "msg.com.00034",
                        onCancel: () => {
                            navigate(URLS.eswi0101001q);
                        },
                    });
                } else {
                    form.hsAppForm.setValues(data.appInfo.content.info);
                    const prcssStatCd = form.hsAppForm.getValue("prcssStatCd");
                    refOfcrInfo.current = data.appInfo.content.ofcrInfo;
                    form.hsVrfnForm.setValues(refOfcrInfo.current);
                    const asinOfcrId = refOfcrInfo.current.asinOfcrId;
                    console.log(" asinOfcrId ", asinOfcrId);

                    refSavable.current =
                        asinOfcrId &&
                        (asinOfcrId == auth.get("usrId") || asinOfcrId == auth.get("asisSysmUsrId")) &&
                        (prcssStatCd == "RC" || prcssStatCd == "VE");

                    refSubmittable.current =
                        asinOfcrId &&
                        (asinOfcrId == auth.get("usrId") || asinOfcrId == auth.get("asisSysmUsrId")) &&
                        prcssStatCd == "VE";
                }
            },
            onError: () => {
                toast.showToast({ type: "error", content: "msg.com.00025" });
            },
            showToast: false,
        }),
        updateHsVrfnInfo: useFetch({
            api: (hsAppUuid, data) => APIS.updateHsVrfnInfo(hsAppUuid, { ...data }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003" /**Processed successfully. */,
                    onConfirm: () => {
                        handler.setInit();
                    },
                    onCancel: () => {
                        handler.setInit();
                    },
                });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
        }),

        updateHsVrfnInfoSubmit: useFetch({
            api: (hsAppUuid, data) => APIS.updateHsVrfnInfoSubmit(hsAppUuid, { ...data }),
            onSuccess: (data) => {
                modal.openModal({
                    content: "msg.00003" /**Processed successfully. */,
                    onConfirm: () => {
                        modal.closeModal();
                        navigate(URLS.eswi0101001q);
                    },
                    onCancel: () => {
                        handler.setInit();
                    },
                });
            },
            onError: (err) => {
                modal.openModal({ content: err.response.data.errorMessage });
            },
        }),
    };

    /*
     * Declaration Event Handler
     * !== 이벤트 핸들러 정의 ==!
     */
    const handler = {
        updateHsVrfnInfo: form.hsVrfnForm.handleSubmit(async () => {
            const data = form.hsVrfnForm.getValues();
            modal.openModal({
                content: "msg.00101",
                onConfirm: () => {
                    fetch.updateHsVrfnInfo.fetch(hsAppUuid, data);
                },
            });
        }),
        updateHsVrfnInfoSubmit: form.hsVrfnForm.handleSubmit(async () => {
            const data = form.hsVrfnForm.getValues();
            modal.openModal({
                content: "msg.00102",
                onConfirm: () => {
                    fetch.updateHsVrfnInfoSubmit.fetch(hsAppUuid, data);
                },
            });
        }),

        setInit: async () => {
            // ======== 임시 로직 ============ tin으로 기관 정보 조회해서 form에 orgCd, orgNm 값 세팅
            const info = await eswiUtils.setOrgInfoByTin(auth.get("tin"));
            form.hsVrfnForm.setValues({ ...eswiUtils.orgInfo });

            // HS App Information
            await fetch.getHsVrfnInfo.fetch(hsAppUuid);
        },
    };

    // useEffect
    useEffect(() => {
        handler.setInit();
    }, []);

    return (
        <>
            <Group>
                <Group.Body>
                    <Layout>
                        <Layout.Left>
                            <Group.Title title={t("T_APRV_RSTS")} titleSize={1}></Group.Title>
                        </Layout.Left>
                    </Layout>
                    <Group.Section>
                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.hsAppNo} />
                            <Group.Control {...form.hsAppForm.schema.prcssStatCd} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control {...form.hsAppForm.schema.orgNm} />
                            <Group.Control {...form.hsAppForm.schema.orgChpnNm} />
                        </Group.Row>

                        <Group.Row>
                            <Group.Control
                                {...form.hsVrfnForm.schema.prcssStatCd}
                                edit={refSavable.current}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.hsVrfnForm.schema.prcssRsnCn}
                                controlSize={10}
                                edit={refSavable.current}
                            />
                        </Group.Row>
                        <Group.Row>
                            <Group.Control
                                {...form.hsVrfnForm.schema.rmrk}
                                controlSize={10}
                                edit={refSavable.current}
                            />
                        </Group.Row>
                    </Group.Section>

                    <Layout direction="row">
                        <Layout.Left>
                            {refSavable.current && (
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.hsVrfnForm.reset();
                                    }}
                                />
                            )}
                        </Layout.Left>
                        <Layout.Right>
                            {refSavable.current && (
                                <Button
                                    role="save"
                                    onClick={() => {
                                        handler.updateHsVrfnInfo();
                                    }}
                                />
                            )}
                            {refSubmittable.current && (
                                <Button
                                    role="submit"
                                    onClick={() => {
                                        handler.updateHsVrfnInfoSubmit();
                                    }}
                                />
                            )}
                        </Layout.Right>
                    </Layout>
                </Group.Body>
            </Group>
        </>
    );
};
